import { render, staticRenderFns } from "./ToolStd.vue?vue&type=template&id=45bb71b8&scoped=true&"
import script from "./ToolStd.vue?vue&type=script&lang=js&"
export * from "./ToolStd.vue?vue&type=script&lang=js&"
import style0 from "./ToolStd.vue?vue&type=style&index=0&id=45bb71b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb71b8",
  null
  
)

export default component.exports